import { Switch } from '@scaleaq/scaleui';
import { Control, Controller, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type ControlledSwitchProps<T extends FieldValues> = {
  control: Control<T>;
  disabled?: boolean;
  label: string;
  labelPosition?: 'left' | 'right';
  name: Path<T>;
  render?: boolean;
  rules?: Omit<
    RegisterOptions<T, Path<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
};

export const ControlledSwitch = <T extends FieldValues>({
  control,
  disabled,
  label,
  labelPosition,
  name,
  render = true,
  rules,
}: ControlledSwitchProps<T>) => {
  if (!render) return;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Switch
          id={name}
          checked={!!field.value}
          disabled={disabled}
          label={label}
          labelPosition={labelPosition}
          onChange={field.onChange}
        />
      )}
    />
  );
};
